import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ViewUrl } from "../api/moodleUrlApi";
import { handleApiError } from "../api/instanceApi";
import { updateModuleCompletion } from "../api/updateModuleCompletion";

export const useHandleCompleModule = () => {
  const viewUrlMutation = useMutation({
    mutationFn: (urlid: any) => ViewUrl(urlid),
    onError: handleApiError,
  });
  const updateModuleCompletionMutation = useMutation({
    mutationFn: (moduleid: any) => updateModuleCompletion(moduleid),
    onError: handleApiError,
  });
  return {
    viewUrl: viewUrlMutation.mutate,
    viewUrlAsync: viewUrlMutation.mutateAsync,
    updateModuleCompletion: updateModuleCompletionMutation.mutate,
    updateModuleCompletionAsync: updateModuleCompletionMutation.mutateAsync,
  };
};
